import React,{useEffect,useState,useContext} from 'react';
import ReactTooltip from 'react-tooltip';
import { Container, Row, Col, Modal, Button } from 'react-bootstrap';
// , Nav, Form, Table,
//import { Link } from "react-router-dom";

import { apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
//import { HubspotForm } from "Api/HubspotApi.js";

import axios from "axios";

//import { local_routes } from 'utils/Routes';

//import Select from 'react-select';

import UserContext from 'store/UserContext';





//import { assembleNickname, get_current_unix_stamp } from "utils/Helper.js";



import './style.css';

function StartZoomWebinarModal (props) {
  //console.log("OnboardingModal constructor",props);
  
  const user_context = useContext(UserContext);

  //const [tab_choice, setTabChoice] = useState('zoom_webinar_object');

  const [loading, setLoading] = useState(true);
  //const [zoom_webinar_id, setZoomWebinarId] = useState(props.entity_info.zoom_webinar_id || '');
  const [zoom_info, setZoomInfo] = useState({});
  
  const [message, setMessage] = useState(false);

  /*
  const tab_info = {
    zoom_webinar_object: {
      title: "Webinar Information",
    },
    zoom_panelists_array: {
      title: "Panelists",
    },
    zoom_registrants_array: {
      title: "Registrants",
    }
  };
  */

  /*
  async function refreshZoomInfo () {
    console.log("refreshZoomInfo");
    setLoading(true);
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
    await axios.post(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}/refreshZoomInfo`,{});
    setupEntities();
  }
  
  async function syncZoomInfo () {
    console.log("syncZoomInfo");
    setLoading(true);
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
    await axios.post(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}/syncZoomInfo`,{});
    //setupEntities();
  }
  
  function onChangeZoomWebinarId (event) {
    setZoomWebinarId(event.target.value);
  }
  
  async function removeZoom () {
    console.log("removeZoom");
    setLoading(true);
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
    let patch_obj = {
      zoom_webinar_id: '',
      zoom_webinar_object: {},
      zoom_panelists_array: [],
      zoom_registrants_array: [],
      zoom_webinar_zoom_user_email: '',
      zoom_webinar_zoom_user_id: '',
      zoom_webinar_zoom_user_password: ''
    }
    await axios.patch(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}`,patch_obj);
    setZoomWebinarId('');
    props.onWebinarIdChange('');
    setMessage(false);
    setLoading(false);
  }
  
  async function createZoomWebinar () {
    console.log("createZoomWebinar");
    setLoading(true);
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
    let post_obj = {
      topic: props.entity_info.entity_name,
      agenda: props.entity_info['description'].replace(/<[^>]+>/g, ''),
      start_time: props.entity_info.start_time
    }
    let add_zoom_webinar_response = await axios.post(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}/addZoomWebinar`,post_obj);

    // bust cache
    axios.get(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.friendly_url}`,myHeaders_Auth_With_Cache_Control);
    
    // put 11-digit zoom_webinar_id into 3-4-4 string
    let tmp_new_zoom_webinar_id = add_zoom_webinar_response.data.zoom_webinar_id;
    //tmp_new_zoom_webinar_id = tmp_new_zoom_webinar_id.slice(0,3)+' '+tmp_new_zoom_webinar_id.slice(3,4)+' '+tmp_new_zoom_webinar_id.slice(7,4);
    
    setZoomWebinarId(tmp_new_zoom_webinar_id);
    props.onWebinarIdChange(add_zoom_webinar_response.data.zoom_webinar_id);
    await refreshZoomInfo();
  }
  
  async function saveZoomWebinarId () {
    console.log("changeZoomWebinarId");
    if (!zoom_webinar_id.match(/^[0-9]{3} [0-9]{4} [0-9]{4}$/)) {
      setMessage(<span style={{ color: 'red', fontSize: 'smaller' }}> Incorrect Zoom Webinar ID format</span>);
      return;
    }
    setLoading(true);
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
    let patch_obj = {
      zoom_webinar_id,
      zoom_webinar_object: {},
      zoom_panelists_array: [],
      zoom_registrants_array: []
    }
    try {
      await axios.patch(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}`,patch_obj);
    } catch (err) {
      // probably already used zoom webinar id
      setMessage(<span style={{ color: 'red', fontSize: 'smaller' }}> ERROR: Zoom Webinar ID already in use by another event</span>);  
      return;      
    }
    props.onWebinarIdChange(zoom_webinar_id);
    await syncZoomInfo();
    await refreshZoomInfo();
    
    // bust cache
    axios.get(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.friendly_url}`,myHeaders_Auth_With_Cache_Control);
  }
  */

  async function setupEntities () {
    setLoading(true);
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);

    let params = {
      attributes: ['zoom_webinar_object','zoom_webinar_zoom_user_email','zoom_webinar_zoom_user_password']
    }

    let zoom_info_response = await axios.get(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}`, { params, ...myHeaders_Auth_With_Cache_Control } );

    //if (tmp_tab_choice === 'zoom_webinar_object') {
      // display useful things
    //}
    
    if (zoom_info_response.data.zoom_webinar_object && zoom_info_response.data.zoom_webinar_object.start_url) {
      // trim to not show secret token thing
      zoom_info_response.data.zoom_webinar_object.start_url_trimmed = zoom_info_response.data.zoom_webinar_object.start_url.split('?').shift();
    }
    if (zoom_info_response.data.zoom_webinar_zoom_user_email) {
      zoom_info_response.data.zoom_webinar_zoom_user_email_full = zoom_info_response.data.zoom_webinar_zoom_user_email+'@pechakucha.com';
    } else {
      zoom_info_response.data.zoom_webinar_zoom_user_email_full = 'Please Contact Support';
    }

    console.log("zoom_info_response",zoom_info_response.data);
    setZoomInfo(zoom_info_response.data);

    setMessage(false);
    setLoading(false);
  }

  /*
  function changeTab (eventKey) {
    console.log("changeTab",eventKey,tab_choice);
    if (eventKey !== tab_choice) {
      setZoomInfo({});
      setMessage(false);
      setTabChoice(eventKey);
      setupEntities(eventKey);
    }
  }
  */

  useEffect(() => {
    ReactTooltip.rebuild();
  }, [props.entity_info]);

  // on mount
  useEffect(() => {
    console.log("StartZoomWebinarModal useEffect props.show");

    if (!props.entity_info.entity_uuid) {
      return;
    }
    
    //if (zoom_webinar_id) {
      setupEntities();
    //} else {
      //setLoading(false);
    //}
    
  }, [props.show]);
  
  function renderZoomInfo() {
    let contents = <React.Fragment></React.Fragment>;
    
      contents =
        <React.Fragment>
          <Row>
            <Col xs={3}>
              Step 1:
            </Col>
            <Col style={{ fontSize: "smaller" }}>
              Login to Zoom with the following PechaKucha Webinar Host credentials:<br/>
              Email: {zoom_info.zoom_webinar_zoom_user_email_full || 'Please Contact Support'}<br/>
              Password: {zoom_info.zoom_webinar_zoom_user_password || 'Please Contact Support'}<br/>
              <em>Note that if you are already logged in to Zoom with a personal account, you will have to logout/switch users</em>
            </Col>
          </Row>
          <hr/>
          <Row>
            <Col xs={3}>
              Step 2:
            </Col>
            <Col>
              Start your webinar by clicking the following link:<br/>
              <a style={{ fontSize: 'smaller' }} target="_blank" href={zoom_info.zoom_webinar_object.start_url_trimmed}>{zoom_info.zoom_webinar_object.start_url_trimmed}</a>
            </Col>
          </Row>
          <hr/>
        </React.Fragment>;

    
    return contents;
  }
  
  return (
    <Modal
      style={{ color: 'black' }}
      show={props.show}
      onHide={props.onHide}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable={true}
    >
      <Modal.Header closeButton>
        <Container>
          <Row>
            <Col xs={6}>
              <Modal.Title id="contained-modal-title-vcenter">
                Start Zoom Webinar
              </Modal.Title>
            </Col>
          </Row>
        </Container>
      </Modal.Header>
      { props.entity_info.zoom_webinar_id &&
        <Modal.Body style={{ overflowX: "visible" }} >
          <Container style={{ height: "400px" }}>
            <Row style={{ marginBottom: "20px" }}>
              <Col>
                { !loading &&
                  <React.Fragment>
                    {renderZoomInfo()}
                  </React.Fragment>
                }
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      }
      <ReactTooltip/>
    </Modal>
  );
}

function StartZoomWebinarModalButton (props) {
  const [modalShow, setModalShow] = React.useState(false);

  console.log("ZoomControlModalButton",props);

  let button_icon = <i className="fa fa-plug" aria-hidden="true"></i>;
  let button_text = 'Start Zoom Webinar';
  let button_tooltip = 'Start Zoom Webinar';
  
  if (props.entity_info.zoom_webinar_id) {
    button_text = 'Start Zoom Webinar';
    button_icon = <i className="fa fa-hand-o-right" aria-hidden="true"></i>;
    button_tooltip = 'Click to Start Your Connected Zoom Webinar'
  } else if (props.disabled === true) {
    button_tooltip = 'Click \'Save + Next\' to Create your Event, and then Connect Zoom';
  }
  //let button_tooltip = 'Click to see more options';

  return (
    <React.Fragment>
      <div data-tip={button_tooltip}>
      <Button
        disabled={props.disabled === true ? true : false}
        
        variant="pkprimary"
        onClick={() => setModalShow(true)}
        size="sm"
      >
        {button_text} {button_icon}
        <ReactTooltip/>
      </Button>
      </div>
    
      <StartZoomWebinarModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        entity_info={props.entity_info}
        onWebinarIdChange={props.onWebinarIdChange}
      />
      
    </React.Fragment>
  );
}

export default StartZoomWebinarModalButton;